import React, { useEffect, useMemo } from "react";
import _ from "lodash";
import {
  ContentWithImage,
  Headline,
  Loading,
  SectionContent,
  Text,
  WidgetCard,
  WidgetCardsContainer,
} from "../../../../components";
import {
  applyKey,
  formatCurrency,
  formatNumber,
  formatDate,
  parseISO,
} from "../../../../utils";
import { usePremiometro } from "../../../../hooks";
import { ReactComponent as IlustraSacoDinheiro } from "../../../../assets/images/capitalizacao/ilustracao-saco-de-moedas.svg";
import { Caption } from "./Premiometro.Style";

const dataInicial = parseISO("2012-01-01");

const Premiometro = () => {
  const { premios, getResult, loading, error } = usePremiometro();

  useEffect(() => {
    if (!premios && !loading && !error) {
      getResult();
    }
  }, [error, getResult, loading, premios]);

  const periodo = useMemo(() => {
    const currentDate = new Date();

    return _.capitalize(
      `Dados de ${formatDate(dataInicial, "MMM/yyyy")} a ${formatDate(
        currentDate,
        "MMM/yyyy"
      )}`
    );
  }, []);

  return (
    <Loading loading={loading}>
      <SectionContent>
        <ContentWithImage image={<IlustraSacoDinheiro />}>
          <Headline nivel="2" styleAs="5" text="Prêmiometro" />
          <Text ajustBottom="16px">
            Confira abaixo o volume milionário de nossas premiações. Quem sabe
            você não entra para as estatísticas do nosso premiômetro?
          </Text>

          <WidgetCardsContainer>
            {applyKey(
              [
                {
                  title: "TOTAL DE PRÊMIOS EM DINHEIRO",
                  body: formatCurrency(premios?.valorPremio),
                },
                {
                  title: "GANHADORES",
                  body: formatNumber(premios?.qdtTitulos),
                },
              ],
              ({ title: cardTitle, body: cardBody }) => (
                <WidgetCard
                  header={
                    <Text textType="caption" bodyStrong text={cardTitle} />
                  }
                  backgroundLevel="07"
                >
                  <Text
                    textType="headline"
                    styleAs="4"
                    reset={{ marginBottom: "0px" }}
                    text={cardBody}
                  />
                </WidgetCard>
              )
            )}
          </WidgetCardsContainer>
          <Caption textType="caption" text={periodo} />
        </ContentWithImage>
      </SectionContent>
    </Loading>
  );
};

Premiometro.propTypes = {};

export default Premiometro;
